/**
 * DeviceItem class, used in CheckUncheckDevices class below
 */
function DeviceItem (include = false, disabled = false) {
  this.include = include
  this.disabled = disabled
}

/**
 * CheckUncheckDevices class, used in ActivationPaymentsCtrl
 *
 * @class CheckUncheckDevices
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 * @name mwApp/subscribers.class:CheckUncheckDevices
 */
export default function CheckUncheckDevices (min = 0, max = 0) {
  Object.defineProperty(this, 'min', { value: min, configurable: true })
  Object.defineProperty(this, 'max', { value: max, configurable: true })
  for (let i = min; i < max; i++) {
    this[i] = new DeviceItem()
  }
}

CheckUncheckDevices.prototype = {

  update (min, max) {
    for (let i = Math.min(min, this.min); i <= Math.max(max, this.max); i++) {
      if (this[i] && (i < min || max < i)) { // squeeze
        delete this[i]
      } else
      if (!this[i] && (min <= i && i <= max)) { // extend
        this[i] = new DeviceItem()
      }
    }
    Object.defineProperty(this, 'min', { value: min, configurable: true })
    Object.defineProperty(this, 'max', { value: max, configurable: true })
    return this
  },

  includeFirst () {
    if (this[this.min]) {
      this[this.min].include = true
    }
    return this
  },

  includeAll () {
    for (let i = this.min; i <= this.max; i++) {
      this[i].include = true
    }
    return this
  },

  disableAfter (n) {
    if (n >= 0) {
      for (let i = this.min; i <= this.max; i++) {
        if (i >= n) {
          this[i].include = false
          this[i].disabled = true
        } else {
          this[i].disabled = false
        }
      }
    }
    return this
  },

  change (n) {
    for (let i = this.min; i <= this.max; i++) {
      if (i !== +n) {
        this[i].include = i < +n
      }
    }
    return this
  },

  count () {
    let ret = 0
    for (let i = this.min; i <= this.max; i++) {
      ret += +this[i].include
    }
    return ret
  }

}
